import React from 'react'
import { Button } from '../../../components'
import { useMediaQuery } from '../../../hooks'
import { postActusParams } from '../../../types'
import style from './style.module.scss'

type SlideContentProps = {
    post: postActusParams
}

const SlideContent: React.FC<SlideContentProps> = ({ post }) => {
    const isMobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')')

    return (
        <div className={style.content}>
            <div className={style.taxs}>
                {post.parentTax && (
                    <>
                        <a href={post.parentTax.link}>{post.parentTax.name}</a>
                        <span>/</span>
                    </>
                )}
                {post.tax && <a href={post.tax.link}>{post.tax.name}</a>}
            </div>

            <a className={style.title} href={post.link}>
                {post.title}
            </a>

            {!isMobile && (
                <Button
                    text={'Lire la suite'}
                    type={'filled-arrow'}
                    link={post.link}
                    blank={false}
                    isInternal={false}
                    isDownload={false}
                    fullWidth={false}
                    picto=""
                />
            )}
        </div>
    )
}

export default SlideContent
